import Piano from './components/Piano';
import NOTES from './constants/NOTES';

export default Piano;

export { NOTES };



// WEBPACK FOOTER //
// ./src/lib/index.js